import { authInstance } from "apis";
import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import ApiError from "types/ApiError";

interface Params {
  projectId?: number;
  onSuccess: () => void;
  onError: () => void;
}

interface DTO {
  sceneId: number;
  xCoordinate: string;
  yCoordinate: string;
  productOptionId: number;
}

const useCreatePin = ({ projectId, onSuccess, onError }: Params) => {
  const queryClient = useQueryClient();

  const fetcher = async (dto: DTO) => {
    const { data } = await authInstance.post("/pin", dto);
    return data;
  };

  const { mutate } = useMutation(fetcher, {
    onSuccess: () => {
      queryClient.invalidateQueries(`project/${projectId}`);
      onSuccess();
    },
    onError: (error: AxiosError<ApiError>) => {
      alert(error.response?.data.message);
      onError();
    },
  });

  return mutate;
};

export default useCreatePin;
